import TRACKING_STATUS from './tracking-status.constants';

export default {
  CANCELED_AFTER_PROCESSING: [
    TRACKING_STATUS.PROCESSING,
    TRACKING_STATUS.IN_ROUTING,
    TRACKING_STATUS.NOT_DELIVERED,
    TRACKING_STATUS.CANCELED
  ],
  CANCELED_BEFORE_PROCESSING: [TRACKING_STATUS.CANCELED],
  DELIVERED: [
    TRACKING_STATUS.PROCESSING,
    TRACKING_STATUS.IN_ROUTING,
    TRACKING_STATUS.DELIVERED
  ],
  NOT_DELIVERED_OR_RETURNED_AFTER_IN_ROUTING: [
    TRACKING_STATUS.PROCESSING,
    TRACKING_STATUS.IN_ROUTING,
    TRACKING_STATUS.NOT_DELIVERED,
    TRACKING_STATUS.IN_TREATMENT,
    TRACKING_STATUS.RETURNED
  ],
  RETURNED_BEFORE_IN_ROUTING: [
    TRACKING_STATUS.PROCESSING,
    TRACKING_STATUS.RETURNED
  ]
};
